export default __webpack_public_path__ + "static/media/design.326ca285.jpeg";